<template>
  <a-row :gutter="[16, 16]">
    <a-col :span="24">
      <a-card class="header">
        <a-row :gutter="[16, 16]" align="middle" justify="center" type="flex">
          <a-col :lg="10" :md="24" :sm="24" :xl="10" :xs="24" :xxl="8">

            <h1 class="header-text">Przerwa techniczna! <span style="color: #faad14"><span class="no-orphan">Za
                  chwilę</span>
                wracamy!</span>
            </h1>
            <p class="sub-header-text"><strong>Jesteśmy w trakcie udoskonalania naszej usługi, <span class="no-orphan">aby
                  zapewnić</span> Państwu jeszcze
              lepsze wrażenia.</strong>
            </p>
            <br/>
            <p class="sub-header-text">
              <small>Prosimy <span class="no-orphan">o cierpliwość</span> <span class="no-orphan">i
                  wyrozumiałość,</span></small><br/>
              <small>Zespół Administratorów Sieci Akademickiej</small>
            </p>
          </a-col>
          <a-col :lg="14" :md="0" :sm="0" :xl="14" :xs="0" :xxl="16">
            <VueLottiePlayer :animationData="require('@/assets/work-in-progress.json')" :width="'auto'" loop
                             name="Server Animation" style="height: 65vh; max-height: 500px;"/>
          </a-col>
        </a-row>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "Maintenance",
  components: {
    VueLottiePlayer,
  },
  mounted() {
    this.$emit("loadedView");

    setTimeout(() => {
      window.location.reload()
    }, 10000);
  },
  methods: {
    refreshPage() {
      this.$router.go();
    },
  },
};
</script>


<style scoped>
.header {
  background: rgb(0, 33, 61);
  background: linear-gradient(120deg, rgba(0, 22, 40, 1) 5%, rgba(25, 144, 255, 1) 200%);
  padding: 2vh 5vw;
}

@media screen and (min-width: 992px) {
  .header {
    background: rgb(0, 33, 61);
    background: linear-gradient(120deg, rgba(0, 22, 40, 1) 10%, rgba(25, 144, 255, 1) 120%);
    padding: 1vh 10vw;
  }
}

.header-text {
  font-size: 3em;
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1),
  4px 4px 0px rgba(0, 0, 75, 1),
  5px 5px 0px rgba(0, 0, 75, 1);
}

.sub-header-text {
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1);
}
</style>